import { render, staticRenderFns } from "./CompleteNewPassword.vue?vue&type=template&id=0068d8e6&scoped=true&"
import script from "./CompleteNewPassword.vue?vue&type=script&lang=ts&"
export * from "./CompleteNewPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0068d8e6",
  null
  
)

export default component.exports